<template>
  <div class="dg__upload2" :class="{ inline: inline }">
    <div class="relative upload-box">
      <div v-if="$slots.default">
        <slot></slot>
      </div>
      <div v-if="!$slots.default" class="img-upload flex">
        <i class="icon" v-show="!url">&#xe60b;</i>
        <img class="preview" :src="url" v-show="url" />
      </div>
      <input class="file-input dg__upload_input" type="file" :accept="type.toString()" @change="upfile" />
    </div>
  </div>
</template>

<script>
const hasOwnProperty = Object.prototype.hasOwnProperty;
export default {
  name: "dg-upload2",
  inject: ["elForm", "elFormItem"],
  props: {
    noUpload: Boolean,
    value: String | Array,

    tip: String,
    buttonSize: {
      type: String,
      default: "small",
    },
    code: String,
    attrs: Object,
    size: {
      type: Number,
      default: 10,
    },
    accept: {
      type: String,
      default: "image/png, image/jpeg, image/jpg",
    },
    type: {
      type: Array,
      default: () => {
        return [".jpg", ".jpeg", ".png"];
      },
    },
    button: Boolean,
    inline: Boolean,
  },
  data() {
    return {
      url: "",
      tips: "仅限上传一张图片，大小不超过5M",
    };
  },
  watch: {
    value: {
      handler(val) {
        this.url = val;
      },
      immediate: true,
    },

    tip: {
      handler(val) {
        this.tips = val;
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * @author 伟健 / 张
     * @name 删除
     * @param
     * @return
     */
    hanldeDel() {
      if (this.url instanceof Array) {
        this.url = [];
      } else {
        this.url = "";
      }

      this.$emit("change", { url: this.url, name: "" });
      this.$emit("input", this.url);
      // if (formItem) {
      //   formItem.validate("change").catch(err => debugWarn(err));
      // }
    },
    upfile(e) {
      var file = e.target.files[0]; //获取上传的文件
      let { size, name } = file;

      var suffix = this.getSuffix(name);
      var maxSize = 1048576 * this.size; //最大5MB
      if (size > maxSize) {
        this.$message({
          message: `上传的文件不能超过${this.size}MB`,
          type: "error",
        });
        return;
      }
      if (this.type.length && this.type.indexOf(suffix) == -1 && this.type[0] != "*") {
        this.$message({
          message: `文件类型错误,请上传${this.type.join(" ")}`,
          type: "error",
        });
        return;
      }
      var formData = new FormData();
      formData.append("fileName", file);
      this.$emit("file", file);
      if (this.noUpload) {
        return;
      }
      this.$emit("before");

      ajax.uploadFile({
        url: "/supplyChain/upload",
        data: formData,
        self: this,
        success: (res) => {
          this.$emit("after");
          if (res) {
            if (this.url instanceof Array) {
              let d = { ...this.attrs };
              if (this.attrs && this.attrs["key"]) {
                d[this.attrs["key"]] = res;
              } else {
                d["url"] = res;
              }
              if (this.attrs && hasOwnProperty.call(this.attrs, "name")) {
                d["name"] = file.name;
              }
              if (this.attrs && hasOwnProperty.call(this.attrs, "size")) {
                d["size"] = file.size;
              }
              delete d["key"];
              this.url.push(d);
            } else {
              this.url = res;
            }
            this.$emit("change", { url: this.url, name: name });
            this.$emit("input", this.url);
            if (this.elFormItem && this.elFormItem.prop) {
              this.elForm && this.elForm.clearValidate(this.elFormItem.prop);
            }

            // if (formItem) {
            //   formItem.validate("change").catch((err) => debugWarn(err));
            // }
          }

          e.target.value = "";
        },
        fail: (err) => {
          console.log(err);
          e.target.value = "";
          this.$message({ message: `图片上传失败`, type: "error" });
        },
      });
    },
    getSuffix(str) {
      var d = str.split(".");
      return "." + d[d.length - 1];
    },
  },
  mounted() {
    console.log();
    console.log();
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/css/var.less';
.dg__upload2 {
  cursor: pointer;

  &.inline {
    display: inline-block;
    margin-right: 10px;
    vertical-align: top;
  }

  .file-input {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 5;
    cursor: pointer;
    opacity: 0;
  }

  .preview {
    position: absolute;
    top: 1%;
    left: 1%;
    width: 98%;
    height: 98%;
    object-fit: cover;
    object-position: center;
    display: block;
    border-radius: 4px;
  }

  .url-box {
    width: 200px;
    color: #c7c7c7;
    font-size: 12px;
    padding-top: 5px;

    &.inline {
      width: 170px;
    }
  }

  a:hover {
    text-decoration: underline;
    color: #c7c7c7;
  }
}

.img-upload {
  width: 100px;
  height: 100px;
  border-radius: 4px;
  border: 1px dashed #c7c7c7;
  cursor: pointer;

  i {
    margin: auto;
    font-size: 30px;
    color: #c7c7c7;
  }
}

.tip {
  font-size: 12px;
  color: #c7c7c7;
  padding-top: 5px;
}
</style>
 <style>.inline {
    display: inline
}
.relative {
    position: relative
}
.flex {
    display: flex
}</style>